export const GET_SAVED_PRODUCTS = 'GET_SAVED_PRODUCTS'
export const SAVE_PRODUCT = 'SAVE_PRODUCT'
export const DELETE_SAVED_PRODUCTS = 'DELETE_SAVED_PRODUCTS'
export const SAVE_ITEM = 'SAVE_ITEM'
export const DELETE_SAVED_ITEMS = 'DELETE_SAVED_ITEMS'
